import { MuteUnmuteDialogMode } from "features/CenterContent/RoleContent/EventHandling/components/MuteEventDialog";
import { useCallback, useState } from "react";

type UseMuteActionsParams = {
  notifying: boolean;
  muted: boolean;
  canToggleNotify: boolean;
  setNotifying: (value: boolean) => void;
  setMuteDialogOpen: (value: boolean) => void;
};

export const useMuteActions = ({
  notifying,
  muted,
  canToggleNotify,
  setNotifying,
  setMuteDialogOpen,
}: UseMuteActionsParams) => {
  const [muteDialogMode, setMuteDialogMode] =
    useState<MuteUnmuteDialogMode>("mute");

  const handleToggleNotify = useCallback(() => {
    if (!canToggleNotify) {
      return;
    }
    if (notifying) {
      setMuteDialogMode("mute");
      setMuteDialogOpen(true);
    } else if (muted) {
      setMuteDialogMode("unmute");
      setMuteDialogOpen(true);
    } else {
      setNotifying(true);
    }
  }, [canToggleNotify, muted, notifying, setMuteDialogOpen, setNotifying]);

  return {
    muteDialogMode,
    handleToggleNotify,
  };
};
